import { Component, Input, ViewChild } from '@angular/core';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'enaio-document-file-preview',
    templateUrl: './document-file-preview.component.html',
    styleUrls: ['document-file-preview.component.scss']
})
export class DocumentFilePreviewComponent {

    @ViewChild('viewer') viewer;

    _documentToken: string = null;
    
    @Input()
    set documentToken(value: string) {
        this._documentToken = value;
        this.updateViewer();
    }

    private updateViewer(): void {
        if (Utils.isNoe(this._documentToken)) {
            if (this.viewer != null) {
                this.viewer.pdfSrc = "";
                this.viewer.refresh();
            }
        }
        else {
            RestEndpoint.main().query({token: this._documentToken, convert: true}).runBlob("api/doc/document/document").then(b => {
                if (this.viewer != null) {
                    this.viewer.pdfSrc = b;
                    this.viewer.refresh();
                }
            }).catch(_ => {
                if (this.viewer != null) {
                    this.viewer.pdfSrc = "";
                    this.viewer.refresh();
                }
            });
        }
    }
}
